import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaterialInput from "@Shared/components/inputs/material-input";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ESignAddRolesPage",
  components: {
    InlinePrompt,
    MaterialInput
  },
  mixins: [validationMixin],
  props: {
    signerRoles: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      roleToAdd: ""
    };
  },
  validations: {
    signerRoles: {
      required
    },
    roleToAdd: {
      required
    }
  },
  computed: {
    isValid() {
      return !this.$v.signerRoles.$invalid;
    },
    roleToAddValid() {
      return !this.$v.roleToAdd.$invalid;
    },
    signerRolesWithIndexes() {
      var _context;
      return _mapInstanceProperty(_context = this.signerRoles).call(_context, (signerRole, index) => _objectSpread(_objectSpread({}, signerRole), {}, {
        index
      }));
    },
    table() {
      return {
        columns: ["signerType", "actions"],
        options: {
          skin: "table table-hover",
          filterable: false,
          sortable: [],
          perPage: 999999,
          headings: {
            signerType: this.$tc("e-sign-package.signerType", 2),
            actions: this.$t("global.words.actions")
          },
          showChildRowToggler: false,
          tabbable: false,
          columnsClasses: {
            signerType: "w-90",
            actions: "w-10"
          }
        }
      };
    }
  },
  watch: {
    isValid: {
      handler(value) {
        this.$emit("valid", value);
      },
      immediate: true
    }
  },
  methods: {
    handleDeleteRole(index) {
      this.$emit("delete-role", index);
    },
    handleAddRole() {
      if (!this.roleToAdd) return;
      this.$emit("add-role", {
        name: this.roleToAdd
      });
      this.roleToAdd = "";
    }
  }
});